/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./indexBeta.vue?vue&type=template&id=d510cff2&scoped=true&"
import script from "./indexBeta.vue?vue&type=script&lang=js&"
export * from "./indexBeta.vue?vue&type=script&lang=js&"
import style0 from "./indexBeta.vue?vue&type=style&index=0&id=d510cff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d510cff2",
  null
  
)

export default component.exports